import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';

import { AlertTypeModel } from '../../../../../models/alert-type.model';
import { AlertModel } from '../../../../../models/alert.model';
import { DynamicFormFieldModel } from '../../../../../models/dynamic-form-field.model';
import { AlertsResource } from '../../../../../services/resources/alerts.resource';

@Component({
    selector: 'sl-alert-parameters-form',
    templateUrl: './alert-parameters-form.component.html',
    styleUrls: ['./alert-parameters-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertParametersFormComponent implements OnInit, OnChanges {
    @Input() formGroupName!: string;
    @Input() alertType?: AlertTypeModel;
    @Input() alert?: AlertModel;

    formGroup: FormGroup;
    dynamicFormFields: DynamicFormFieldModel[] = [];
    didParametersLoad = false;

    private readonly formGroupDirective = inject(FormGroupDirective);
    private readonly alertsResource = inject(AlertsResource);

    ngOnInit(): void {
        this.formGroup = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['alertType']?.currentValue) {
            return;
        }

        this.didParametersLoad = false;

        this.alertsResource.getAlertTypeParameters(changes['alertType'].currentValue.className).subscribe(res => {
            this.dynamicFormFields = res.value;
            this.generateParametersForm();
            this.didParametersLoad = true;
        });
    }

    generateParametersForm(): void {
        for (const controlName of Object.keys(this.formGroup.controls)) {
            this.formGroup.removeControl(controlName);
        }

        const currentParametersValue = this.alert ? JSON.parse(this.alert.parametersJson) : undefined;

        for (const parameter of this.dynamicFormFields) {
            const currentValue = currentParametersValue ? currentParametersValue[parameter.key] : undefined;
            this.formGroup.addControl(parameter.key, new FormControl(currentValue));
        }
    }
}
